import styled from 'styled-components';

import { device } from 'styles/breakpoints';

const Wrapper = styled.div`
  font-family: ${({ theme }) => theme.typography.fontFamily.Inter};
  color: ${({ theme }) => theme.colors.blackPallet6};
  display: flex;
  flex-direction: column;

  .get-callback-cta {
    gap: 10px;

    &:disabled {
      display: flex;
      align-items: center;
    }

    img.tick-icon {
      filter: brightness(0) invert(1);
    }
  }

  @media ${device.tablet} {
    .get-callback-cta {
      margin-bottom: 96px;
    }
  }
`;

const ResultWrapper = styled.div`
  min-height: calc(100vh - 95px);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  padding: 0 182px 20px 70px;

  @media ${device.laptop} {
    padding: 0 30px 20px;
  }

  @media ${device.tablet} {
    flex-direction: column;
    align-items: flex-start;
    gap: 40px;
    padding: 20px;
  }
`;

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const AddressWrapper = styled.div`
  height: fit-content;
  display: flex;
  align-items: center;
  gap: 10px;

  > span {
    width: 15px !important;
    height: 15px !important;
  }
`;

const Address = styled.p`
  font-size: 14px;
  font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
  line-height: 19px;
  color: ${({ theme }) => theme.colors.blackPallet6};

  @media ${device.mobile} {
    font-size: 12px;
    line-height: 17px;
  }
`;

const ButtonLink = styled.button`
  font-size: 14px;
  font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
  color: ${({ theme }) => theme.colors.green};
  text-align: center;
  text-decoration-line: underline;
  background-color: transparent;
  text-underline-offset: 3px;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.greenPallet6};
  }
`;

const EstimationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 30px;

  @media ${device.tablet} {
    margin-top: 20px;
  }
`;

const EstimationHeading = styled.p`
  font-size: 16px;
  font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
  line-height: 21px;
  color: ${({ theme }) => theme.colors.grayPallet9};

  @media ${device.mobile} {
    font-size: 14px;
    line-height: 19px;
  }
`;

const EstimationPrice = styled.p`
  font-size: 55px;
  font-weight: ${({ theme }) => theme.typography.fontWeights.bold};
  color: ${({ theme }) => theme.colors.greenPallet5};

  @media ${device.mobile} {
    font-size: 32px;
  }
`;

const Divider = styled.div`
  max-width: 413px;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.grayPallet18};

  @media ${device.mobile} {
    max-width: 265px;
  }
`;

const EstimationNote = styled.p`
  max-width: 471px;
  font-size: 12px;
  font-weight: ${({ theme }) => theme.typography.fontWeights.regular};
  line-height: 17px;
  color: ${({ theme }) => theme.colors.grayPallet9};

  @media ${device.mobile} {
    font-size: 10px;
    line-height: 14px;
  }
`;

const ChartWrapper = styled.div`
  margin-top: 38px;

  @media ${device.tablet} {
    margin-top: 25px;

    &.--desktop {
      display: none;
    }

    &.--tablet {
      > span {
        width: 100% !important;
        height: 305px !important;
      }
      margin-bottom: 80px;
    }
  }

  @media ${device.mobile} {
    &.--tablet {
      > span {
        width: 100% !important;
        height: 170px !important;
      }
    }
  }
`;

const Note = styled.p`
  max-width: 560px;
  font-size: 17px;
  font-weight: ${({ theme }) => theme.typography.fontWeights.semibold};
  line-height: 23px;
  color: ${({ theme }) => theme.colors.blackPallet6};
  margin: 50px 0 20px;

  @media ${device.tablet} {
    margin: 30px 0 15px;
  }

  @media ${device.mobile} {
    font-size: 14px;
    line-height: 19px;
  }
`;

const ButtonContained = styled.button`
  width: fit-content;
  display: flex;
  align-items: center;
  font-size: 17px;
  font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.green};
  text-align: center;
  padding: 17px 34px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.greenPallet6};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.grayPallet18};
    cursor: default;
  }

  @media ${device.mobile} {
    padding: 10px 12px;
  }
`;

const RightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;

  iframe {
    width: 352px !important;
    height: 543px !important;
    box-shadow: 0px 6px 15px 0px ${({ theme }) => theme.colors.black}14;
  }

  @media ${device.tablet} {
    width: 100%;

    #frontchat-repostion-wrapper {
      width: 100%;
    }

    iframe {
      width: 100% !important;
    }
  }
`;

const ChatBotNote = styled.p`
  display: none;
  font-size: 14px;
  font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
  line-height: 19px;
  color: ${({ theme }) => theme.colors.greenPallet5};

  @media ${device.tablet} {
    display: block;
  }
`;

const CMAWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .cma-toggle-cta {
    font-size: 17px;
    align-self: center;
    margin: 40px 0 60px;
  }
`;

const CMAContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.whitePallet3};
  padding: 136px 0 136px 70px;

  @media ${device.laptop} {
    padding: 136px 0 136px 30px;
  }

  @media ${device.tablet} {
    padding: 30px 20px;
    margin-top: 40px;
  }
`;

const ChartHeading = styled.h1`
  font-size: 24px;
`;

const AddressErrorTitle = styled.h1`
  font-size: 55px;
  color: ${({ theme }) => theme.colors.blackPallet7};
  margin-top: 60px;

  @media ${device.mobile} {
    font-size: 32px;
    margin-top: 30px;
  }
`;

const AddressErrorSubtitle = styled.h1`
  max-width: 635px;
  font-size: 40px;
  color: ${({ theme }) => theme.colors.blackPallet7};
  margin-top: 30px;

  @media ${device.mobile} {
    font-size: 22px;
    margin-top: 15px;
  }
`;

const AddressErrorDescription = styled.p`
  max-width: 586px;
  font-size: 17px;
  font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
  line-height: 25px;
  color: ${({ theme }) => theme.colors.blackPallet7};
  margin: 30px 0 40px;

  @media ${device.mobile} {
    font-size: 14px;
    margin: 20px 0;
  }
`;

export default {
  Wrapper,
  ResultWrapper,
  LeftWrapper,
  AddressWrapper,
  Address,
  ButtonLink,
  EstimationWrapper,
  EstimationHeading,
  EstimationPrice,
  Divider,
  EstimationNote,
  ChartWrapper,
  Note,
  ButtonContained,
  RightWrapper,
  ChatBotNote,
  CMAWrapper,
  CMAContent,
  ChartHeading,
  AddressErrorTitle,
  AddressErrorSubtitle,
  AddressErrorDescription,
};
